export default {
    getViewHeaderFields: state => state.viewHeaderFields,
    getViewDataTableOptions: state => state.viewDataTableOptions,
    getViewRowActions: state => state.viewRowActions,
    getViewActions: state => state.viewActions,
    getViewSearchFields: state => state.viewSearchFields,

    getReportHeaderFields: state => state.reportHeaderFields,
    getReportDataTableOptions: state => state.reportDataTableOptions,
    getReportRowActions: state => state.reportRowActions,
    getReportActions: state => state.reportActions,
    getReportSearchFields: state => state.reportSearchFields,
}
